var map = {
	"./Choripapas.jpeg": "86a3",
	"./Chorizo picado.jpeg": "ff26",
	"./Combo Chillidog.jpeg": "2002",
	"./Combo Hamburguesa.jpeg": "26de",
	"./Combo hotdog choridog.jpeg": "c429",
	"./Mega Revoltosa.jpeg": "bac8",
	"./Orden de papas.jpeg": "ce72",
	"./Pescao.jpeg": "e652",
	"./Revoltosa carne,pollo o mixta.jpeg": "08bf",
	"./Salchicha picada.jpeg": "0d49",
	"./agua.jpg": "41ec",
	"./alitas.jpeg": "97e1",
	"./arepa_carne_desmechada.jpeg": "5db9",
	"./arepa_carne_mechada.jpeg": "f258",
	"./arepa_mixta.jpeg": "1b2b",
	"./arepa_pollo.jpg": "67a0",
	"./batido.jpeg": "eed7",
	"./batidos.jpeg": "fa40",
	"./bulldog.jpeg": "047e",
	"./burrito_carne.jpeg": "c692",
	"./burrito_mixto.jpg": "ddf0",
	"./burrito_pollo.jpeg": "d980",
	"./ceviche.jpeg": "6b2a",
	"./chillidog.jpeg": "9ca3",
	"./club_sandwich.jpeg": "7063",
	"./combito_hamburguesa.jpeg": "4e3b",
	"./combito_hawaiiano.jpg": "4880",
	"./combo buldog.jpeg": "46d1",
	"./combo burrito.jpeg": "fbdb",
	"./corvina entera.jpeg": "4b6c",
	"./corvina.jpeg": "ba94",
	"./empanadas.jpeg": "6337",
	"./empty.png": "7c35",
	"./filete_de_pescado.jpeg": "887a",
	"./filete_de_pescado_2.jpeg": "bc8e",
	"./hamburguesa doble carne.jpeg": "e5d5",
	"./hamburguesa_bulldog.jpeg": "3004",
	"./hamburguesa_carne.jpeg": "4216",
	"./hamburguesa_pollo.jpeg": "959f",
	"./hot dog panameño.jpeg": "6f82",
	"./hotdog.jpeg": "f1c2",
	"./hotdog_hawaiiano.jpg": "d992",
	"./hotdog_panameno.jpeg": "9940",
	"./jugos.jpg": "15b4",
	"./limonada.jpg": "13f9",
	"./logo.jpg": "e540",
	"./nachos new.jpeg": "0805",
	"./nachos.jpeg": "0a6d",
	"./orden_papas.jpeg": "72af",
	"./papas con chile y queso.jpeg": "56c5",
	"./papas con tenders.jpeg": "ca29",
	"./patacones.jpg": "3176",
	"./revoltosa.jpeg": "421e",
	"./salchipapas.jpeg": "b076",
	"./salchipapas_revoltosa.jpeg": "79c4",
	"./saus.jpeg": "cae8",
	"./soda.jpg": "ddfe"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c6e7";